/* ============================================
   MAISON KRAFT - Hide Subscriptions Block
   Affiche SEULEMENT pour "les-secrets-de-maison-kraft"
   ============================================ */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    // Méthode 1: Depuis le meta tag Shopify
    let productHandle = document.querySelector('meta[property="og:url"]')?.content?.split('/products/')[1]?.split('?')[0];

    // Méthode 2: Depuis le body data-attribute
    if (!productHandle) {
      productHandle = document.body.getAttribute('data-product-handle');
    }

    // Méthode 3: Depuis le script JSON-LD Shopify
    if (!productHandle) {
      const jsonLd = document.querySelector('script[type="application/ld+json"]');
      if (jsonLd) {
        try {
          const data = JSON.parse(jsonLd.textContent);
          productHandle = data.url?.split('/products/')[1]?.split('?')[0];
        } catch (e) {}
      }
    }

    console.log('📦 Produit actuel (handle):', productHandle);

    // Chercher le conteneur Subscriptions
    const subscriptionsContainer = document.querySelector('.shopify_subscriptions_app_container');

    if (!subscriptionsContainer) {
      console.log('✅ Pas de bloc abonnement trouvé');
      return;
    }

    // Si ce n'est PAS "les-secrets-de-maison-kraft" → CACHER
    if (productHandle !== 'les-secrets-de-maison-kraft') {
      console.log('🔒 Handle "' + productHandle + '" → Masquage du bloc');
      subscriptionsContainer.style.display = 'none';
    } else {
      console.log('✅ Handle "' + productHandle + '" → Affichage du bloc');
      subscriptionsContainer.style.display = 'block';
    }
  });
})();